/**
 * Maison du Blanc — Feedback visuel à l'ajout au panier
 * --------------------------------------------------------
 * Quand l'ouverture automatique du drawer est désactivée
 * (settings.cart_drawer_auto_open = false), rien ne confirme
 * visuellement l'ajout. Ce script anime l'icône panier du header
 * (et du dock mobile) : « pop » du compteur + léger rebond de l'icône.
 *
 * Autonome : s'accroche uniquement à l'événement public et stable
 * du thème (ajaxProduct:added), sans modifier theme.js.
 */
(function () {
  'use strict';

  var settings = (window.theme && window.theme.settings) || {};

  // Si le drawer s'ouvre automatiquement, le feedback serait redondant.
  if (settings.cart_drawer_auto_open !== false) return;

  var CART_BUMP_MS = 650;
  var liveRegion = null;

  function ensureLiveRegion() {
    if (liveRegion) return liveRegion;
    liveRegion = document.createElement('p');
    liveRegion.className = 'sr-only';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('role', 'status');
    document.body.appendChild(liveRegion);
    return liveRegion;
  }

  function announce(message) {
    if (!message) return;
    var region = ensureLiveRegion();
    region.textContent = '';
    // Vider puis réécrire force les lecteurs d'écran à re-annoncer.
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  function bumpCartCounts() {
    var counts = document.querySelectorAll('cart-count');
    Array.prototype.forEach.call(counts, function (count) {
      if (count.hidden) return;

      var icon = count.closest('a, button'); // lien/bouton panier (pour le rebond de l'icône)

      count.classList.remove('is-bumping');
      if (icon) icon.classList.remove('mdb-cart-bumping');
      void count.offsetWidth; // reflow pour pouvoir rejouer l'animation

      count.classList.add('is-bumping');
      if (icon) icon.classList.add('mdb-cart-bumping');

      setTimeout(function () {
        count.classList.remove('is-bumping');
        if (icon) icon.classList.remove('mdb-cart-bumping');
      }, CART_BUMP_MS);
    });
  }

  document.addEventListener('ajaxProduct:added', function () {
    bumpCartCounts();
    announce((window.theme && theme.strings && theme.strings.addedToCart) || '');
  });
})();